export * from './lib/+state/appliances/appliances.effects';
export * from './lib/+state/appliances/appliances.reducer';
export * from './lib/+state/appliances/appliances.selectors';
export * from './lib/+state/brands/brands.reducer';
export * from './lib/+state/brands/brands.selectors';
export * from './lib/+state/catalog.facade';
export * from './lib/+state/catalog.reducer';
export * from './lib/+state/catalog.selectors';
export * from './lib/services/appliances.resolver';
export * from './lib/services/mobile-journey.resolver';
export * from './lib/sky-data-access-catalog.module';

import * as AppliancesActions from './lib/+state/appliances/appliances.actions';
import * as AppliancesSelectors from './lib/+state/appliances/appliances.selectors';
import * as BrandsActions from './lib/+state/brands/brands.actions';
import * as BrandsSelectors from './lib/+state/brands/brands.selectors';
import * as _CatalogActions from './lib/+state/catalog.actions';

export const CatalogActions = {
  ..._CatalogActions,
  ...AppliancesActions,
  ...BrandsActions,
};

export const CatalogSelectors = {
  ...AppliancesSelectors,
  ...BrandsSelectors,
};
